import script from "./PromptOptionTemplateIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptOptionTemplateIndex.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__